class VehicleType {
  constructor(title, maxCapacity, autoDisable) {
    this.title = title;
    this.maxCapacity = maxCapacity;
    this.autoDisable = autoDisable;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allVehicleTypes: [],
      vehicleType: new VehicleType('', 0, false),
      allVehicleTypesForOther: [],
    };
  },
  methods: {
    getListOfVehicleTypesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVehicleTypes').then(() => {
        if (this.$store.state.vehicleTypeModule.successFlag) {

          // this.allVehicleTypesForOther = this.$store.state.vehicleTypeModule.allVehicleTypes;
          this.allVehicleTypesForOther = Array.isArray(this.$store.state.vehicleTypeModule.allVehicleTypes)
            ? this.$store.state.vehicleTypeModule.allVehicleTypes
            : [];

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVehicleTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfVehicleTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllVehicleTypes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVehicleTypes').then(() => {
        if (this.$store.state.vehicleTypeModule.successFlag) {
          // let temp = this.$store.state.vehicleTypeModule.allVehicleTypes;

          let temp = Array.isArray(this.$store.state.vehicleTypeModule.allVehicleTypes)
            ? this.$store.state.vehicleTypeModule.allVehicleTypes
            : [];

          this.allVehicleTypes = [];
          for (let i = 0; i < temp.length; i++) {
            this.allVehicleTypes.push({
              title: temp[i].title ? temp[i].title : '-',
              autoDisable: temp[i].autoDisable ? temp[i].autoDisable : false,
              counter: i + 1,
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllVehicleTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllVehicleTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    validateAddOrEditingVehicleType: function () {
      if (!this.vehicleType.title) {
        this.snackText = 'عنوان نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicleType.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicleType.maxCapacity) {
        this.snackText = 'حداکثر میزان گنجایش باید عددی صحیح بزرگتر از 0 باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      return true;
    },
    addVehicleTypeFunction: function () {
      if (this.validateAddOrEditingVehicleType()) {
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('addVehicleType', this.vehicleType).then(() => {
          if (this.$store.state.vehicleTypeModule.successFlag) {
            this.$refs.confirm.showConfirmDialog = false;
            this.showAddEditModal = false;
            this.disabelConfirm = false;
            this.snackText = ' نوع وسیله نقلیه با موفقیت اضافه شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.vehicleType = new VehicleType('', 0, false);
            this.getAllVehicleTypes();
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.vehicleTypeModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addVehicleTypeFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.vehicleTypeModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addVehicleTypeFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    getVehicleTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVehicleType', id).then(() => {
        if (this.$store.state.vehicleTypeModule.successFlag) {
          this.vehicleType = this.$store.state.vehicleTypeModule.vehicleType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVehicleTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getVehicleTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editVehicleTypeFunction: function () {
      if (this.validateAddOrEditingVehicleType()) {
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('editVehicleType', this.vehicleType).then(() => {
          if (this.$store.state.vehicleTypeModule.successFlag) {
            this.$refs.confirm.showConfirmDialog = false;
            this.disabelConfirm = false;
            this.showAddEditModal = false;
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllVehicleTypes();
            this.snackText = ' نوع وسیله نقلیه با موفقیت ویرایش شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.vehicleType = new VehicleType('', false);
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.vehicleTypeModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.editVehicleTypeFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.vehicleTypeModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.editVehicleTypeFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    deleteVehicleTypeFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteVehicleType', this.vehicleTypeId).then(() => {
        if (this.$store.state.vehicleTypeModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllVehicleTypes();
          this.snackText = 'نوع وسیله نقلیه با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteVehicleTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteVehicleTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vehicleTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
